//#region types
import { GrossSalaryChangeCompanyResult } from "models/propTypes/wintSalaryPropTypes";
import { CurrencyCode } from "models/enums/currency";
import { TranslationKeys } from "translations";
import { SimpleTableRow } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { SimpleAccordionTable } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const formatCurrency = (amount?: number) =>
  amount !== undefined ? LocalizationHelperInstance.getFormattedCurrency(amount, CurrencyCode.SEK) : "-";

const GrossSalaryChangeResult: React.FC<GrossSalaryChangeCompanyResult> = (props) => {
  const { totalCostForCompany, remainingNetAmount, alreadyPaidOutNetAmount, privateTax, socialFees } = props;

  const subRows: SimpleTableRow[] = [
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.GrossSalaryChangeResultRemainingNetAmount),
      value: formatCurrency(remainingNetAmount),
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Salary.GrossSalaryChangeResultAlreadyPaidOutNetAmount
      ),
      value: formatCurrency(alreadyPaidOutNetAmount),
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.GrossSalaryChangeResultTaxCost),
      value: formatCurrency(privateTax),
    },
    {
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.GrossSalaryChangeResultSocialFees),
      value: formatCurrency(socialFees),
    },
  ];

  return (
    <SimpleAccordionTable
      variant="secondary"
      defaultExpanded
      items={[
        {
          title: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.GrossSalaryChangeResultTotalCostForCompany
          ),
          value: formatCurrency(totalCostForCompany),
          subContent: subRows,
        },
      ]}
    />
  );
};

export default GrossSalaryChangeResult;
